import React from 'react'
import HeroDefault from './HeroDefault'

const HeroComp = () => {
  return <HeroDefault />
}

export default HeroComp
